/**
 * Générer une couleur unique pour chaque employé basée sur son ID
 */
export const getEmployeeColor = (employeeId) => {
  const colors = [
    '#3B82F6', // Bleu
    '#10B981', // Vert
    '#F59E0B', // Orange
    '#EF4444', // Rouge
    '#8B5CF6', // Violet
    '#EC4899', // Rose
    '#14B8A6', // Teal
    '#F97316', // Orange foncé
    '#6366F1', // Indigo
    '#84CC16', // Lime
    '#06B6D4', // Cyan
    '#A855F7', // Purple
  ];
  
  // Utiliser le hash de l'ID pour obtenir un index
  let hash = 0;
  for (let i = 0; i < employeeId.length; i++) {
    hash = employeeId.charCodeAt(i) + ((hash << 5) - hash);
  }
  
  const index = Math.abs(hash) % colors.length;
  return colors[index];
};

/**
 * Obtenir une couleur claire pour le fond
 */
export const getEmployeeColorLight = (employeeId) => {
  const color = getEmployeeColor(employeeId);
  // Convertir hex en rgba avec opacité 0.1
  return color + '20'; // Ajoute 20 (hex) = 12.5% opacité
};
